import { cn } from '@/shared/utils';
import { Check, Minus } from 'lucide-react';
import type { MouseEvent } from 'react';

type Props = {
  checked: boolean;
  halfCheck?: boolean;
  size?: number;
  disabled?: boolean;
  onChange?: (status: boolean, e?: MouseEvent) => void;
  className?: string;
  style?: React.CSSProperties;
};

export const Checkbox = (props: Props) => {
  const clickHandler = (e: MouseEvent) => {
    if (!props.onChange) return;
    if (props.disabled) return;
    e.stopPropagation();
    props.onChange(!props.checked, e);
  };
  return (
    <div
      onClick={clickHandler}
      style={props.style}
      className={cn(
        'relative flex h-5 w-6 cursor-pointer items-center justify-center px-1 text-white',
        props.className,
      )}
    >
      <Background checked={props.checked} halfCheck={props.halfCheck} disabled={props.disabled} />
      <div className={CheckWrapperClassName}>
        {props.checked && !props.halfCheck && (
          <Check
            style={{
              fontSize: props.size || 18,
            }}
            className="text-white"
          />
        )}
        {props.halfCheck && (
          <Minus
            style={{
              fontSize: props.size || 18,
            }}
            className="text-white"
          />
        )}
      </div>
    </div>
  );
};

type StyleProps = {
  checked: boolean;
  halfCheck?: boolean;
  disabled?: boolean;
};

const Background = (props: StyleProps) => {
  return (
    <div
      className={cn(
        'absolute z-10 h-3.5 w-3.5 rounded-sm border border-gray-500 bg-transparent transition-all duration-200',
        'hover:bg-primary/20 hover:border-primary',
        props.checked || (props.halfCheck && 'border-primary bg-primary'),
        props.disabled && 'border-gray-300 bg-gray-300',
      )}
    ></div>
  );
};

const CheckWrapperClassName = 'flex-center relative z-20';
